<template>
  <div class="auth-page">
    <div class="auth-page__form">
      <spotley-header/>
      <signup-form/>
    </div>
    <div class="auth-page__bg-image"></div>
  </div>
</template>

<script>
import signupForm from '@/components/signupForm.vue';
import spotleyHeader from '@/components/spotleyHeader.vue';

export default {
  name: 'login',
  components: {
    signupForm,
    spotleyHeader,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_globals.scss";
@import "@/assets/scss/wifi-forms.scss";
</style>
